import { render, staticRenderFns } from "./TeachingCenter.vue?vue&type=template&id=00fba92d&scoped=true&"
import script from "./TeachingCenter.vue?vue&type=script&lang=js&"
export * from "./TeachingCenter.vue?vue&type=script&lang=js&"
import style0 from "./TeachingCenter.vue?vue&type=style&index=0&id=00fba92d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00fba92d",
  null
  
)

export default component.exports